import { RecentlyPage } from './RecentlyPage';

export const recentlyRouter = {
  '/@/my_recent': RecentlyPage,
};
